import React, { useState } from "react";
import axios from "../axiosSetup";
import "./UpdatePasswordPage.css";
import "../pages/LoginPage.css";
import { useNavigate } from "react-router-dom";
import EyeIcon from "../assets/OrgangeEyeIcon.svg";
import { getUser } from "../auth";
import LoginImage from "../assets/LoginPageImage.svg";
import Logo from "../assets/LoginVocovoLogo.svg";

const UpdatePasswordPage = () => {
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");   // NEW
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const [showOld, setShowOld] = useState(false);        //  NEW
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [oldError, setOldError] = useState("");         //  NEW

  const [strength, setStrength] = useState("");
  const handleBack = () => {
  const user = getUser();

  if (user?.role === "customer") {
    navigate("/customer/dashboard");
  } else {
    navigate("/dashboard");
  }
};


  const checkPasswordStrength = (pwd) => {
    let score = 0;
    if (/[A-Z]/.test(pwd)) score++;
    if (/[a-z]/.test(pwd)) score++;
    if (/[0-9]/.test(pwd)) score++;
    if (/[^A-Za-z0-9]/.test(pwd)) score++;
    if (pwd.length >= 8) score++;
    if (score <= 2) return "weak";
    if (score <= 4) return "medium";
    return "strong";
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  setError("");
  setSuccess("");
  setOldError("");
  setPasswordError("");
  setConfirmError("");


  // 1️ Validate old password
  if (!oldPassword.trim()) {
    setOldError("Old password is required");
    return;
  }
// Validate new password empty
if (!password.trim()) {
  setPasswordError("New password is required");
  return;
}
// Validate confirm password empty
if (!confirm.trim()) {
  setConfirmError("Confirm password is required");
  return;
}

  // 2️ Prevent new password being same as old
  if (oldPassword.trim() === password.trim()) {
    setPasswordError("New password cannot be the same as old password.");
    return;
  }

  // 3️ Validate new password match
  if (password !== confirm) {
    setConfirmError("Passwords do not match");
    return;
  }

  // 4️ Strength check
  const st = checkPasswordStrength(password);
  if (st === "weak") {
    setPasswordError("Weak password. Please improve your password.");
    return;
  }

  setLoading(true);

  try {
    await axios.post("/auth/update-password", {
      oldPassword: oldPassword,
      newPassword: password,
    });

    setSuccess("Password updated successfully!");
    setTimeout(() => navigate("/login"), 1800);
  } catch (err) {

    // 5️ Backend old password incorrect → show error near OLD PASSWORD
    if (err.response?.status === 401) {
  setOldError("Old password is incorrect.");
} else {
  setError(
    err.response?.data?.message ||
      "Something went wrong updating password"
  );
}


  } finally {
    setLoading(false);
  }
};


  return (
    <div className="login-page">
      <div className="login-left">
        <img src={LoginImage} alt="Illustration" className="login-visual" />
      </div>

      <div className="login-card">
        <div className="logo-box-wrapper">
          <div className="logo-box">
            <img src={Logo} className="login-logo" alt="logo" />
          </div>
        </div>

        <h2 className="login-title">Update Password</h2>

        {success && (
          <div className="upp-alert-success">
            <span className="upp-alert-icon">✓</span>
            {success}
          </div>
        )}

        {error && <p className="upp-error">{error}</p>}

        <form onSubmit={handleSubmit} className="upp-form">

          {/*  OLD PASSWORD FIELD */}
          <div className="upp-group">
            <label className="Passwordtext">Old Password</label>

            <div className="upp-password-wrapper">
              <input
                type={showOld ? "text" : "password"}
                value={oldPassword}
                onChange={(e) => {
                  setOldPassword(e.target.value);
                  setOldError(e.target.value ? "" : "Old password is required");
                }}
                placeholder="Enter old password"
                required
              />

              <img
              src={EyeIcon}
              alt="toggle password"
              className="eye-icon"
              onClick={() => setShowOld(!showOld)}
            />

            </div>

            {oldError && <p className="upp-field-error">{oldError}</p>}
          </div>

          {/* NEW PASSWORD FIELD */}
          <div className="upp-group">
            <label className="Passwordtext">New Password</label>

            <div className="upp-password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => {
                  const value = e.target.value;
                  setPassword(value);

                  if (!value) {
                    setStrength("");
                    setPasswordError("");
                    return;
                  }

                  const st = checkPasswordStrength(value);
                  setStrength(st);
                  setPasswordError("");

                  // keep confirm password in sync
                  if (confirm) {
                    if (value !== confirm) {
                      setConfirmError("Passwords do not match");
                    } else {
                      setConfirmError("");
                    }
                  }

                }}

                placeholder="Enter new password"
                required
              />

              <img
                src={EyeIcon}
                alt="toggle password"
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              />

            </div>
           {strength && (
  <div className="upp-strength-bar">
    <div className={`bar active-${strength}`} />
    <div className={`bar active-${strength}`} />
    <div className={`bar active-${strength}`} />
  </div>
)}


            {strength && (
  <p className={`upp-strength-text ${strength}`}>
    {strength === "weak" && "Weak password"}
    {strength === "medium" && "Medium strength password"}
    {strength === "strong" && "Strong password"}
  </p>
)}


            {passwordError && <p className="upp-field-error">{passwordError}</p>}
          </div>

          {/* CONFIRM PASSWORD FIELD */}
          <div className="upp-group">
            <label className="Passwordtext">Confirm Password</label>

            <div className="upp-password-wrapper">
              <input
                type={showConfirm ? "text" : "password"}
                value={confirm}
                onChange={(e) => {
                  const value = e.target.value;
                  setConfirm(value);

                  // If empty
                  if (!value) {
                    setConfirmError("Confirm password is required");
                    return;
                  }

                  // Compare with password
                  if (!password) {
                    setConfirmError("");
                    return;
                  }

                  if (value !== password) {
                    setConfirmError("Passwords do not match");
                  } else {
                    setConfirmError("");
                  }
                }}

                placeholder="Confirm new password"
                required
              />

              <img
                src={EyeIcon}
                alt="toggle password"
                className="eye-icon"
                onClick={() => setShowConfirm(!showConfirm)}
              />

            </div>

            {confirmError && (<p className="upp-field-error">{confirmError}</p>)}
          </div>

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </button>

          <p
            className="forgot-password back-login"
            onClick={handleBack}
          >
            Back
          </p>
        </form>
      </div>
    </div>
  );
};

export default UpdatePasswordPage;
